const { getPhoneNumber } = require("./phoneNumberUtils");
const { getCountryByDocumentType } = require("./documentTypes");
const {
    COUNTRY_CODE_ES,
    COUNTRY_CODE_DE,
    COUNTRY_CODE_NL,
    COUNTRY_CODE_PT
} = require("../constants/countryCodes");

const {
    NATIONAL_DOCUMENT,
    RESIDENT_DOCUMENT,
    PASSPORT_DOCUMENT,
    OTHER_DOCUMENT
} = require("../constants/documentGroups");

const {
    RESPONSE_OK_DOCUMENT_VALIDATION,
    RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION,
    RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION
} = require("../constants/validations");

const { TYPE_MOBILE } = require("../constants/phoneNumber");
const config = require("../validationConfig");

const validateCellPhone = (value, countryCode) => {
    if (value) {
        
        let phoneNumber = getPhoneNumber(value, countryCode);
        return (
            phoneNumber &&
            phoneNumber.isValid() &&
            phoneNumber.getType() === TYPE_MOBILE
        );
    } else {
        return false;
    }
};

const isValidLengthId = (value, originCountry) => {
    return config[originCountry].lengthId.some(
        lengthId => lengthId === value.length
    );
};

const isValidLengthPassport = (value, originCountry) => {
    return config[originCountry].lengthPassport.some(
        lengthPassport => lengthPassport === value.length
    );
};

const isValidLengthResident = (value, originCountry) => {
    return config[originCountry].lengthResident === value.length;
};

const isValidPatternId = (value, originCountry) => {
    const pattern = config[originCountry].patternId;
    const patt = new RegExp(pattern);
    return patt.test(value);
};

const isValidPatternPassport = (value, originCountry) => {
    const pattern = config[originCountry].patternPassport;
    const patt = new RegExp(pattern);
    return patt.test(value);
};

const isValidPatternResident = (value, originCountry) => {
    const pattern = config[originCountry].patternResident;
    const patt = new RegExp(pattern);
    return patt.test(value);
};

const getValidateNationalDocument = (value, originCountry) => {
    if (!isValidLengthId(value, originCountry))
        return RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION;
    if (
        isValidPatternId(value, originCountry) &&
        config[originCountry].isValidNationalAlgorith(value)
    )
        return RESPONSE_OK_DOCUMENT_VALIDATION;
    return RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION;
};

const getValidatePassport = (value, originCountry) => {
    if (!isValidLengthPassport(value, originCountry))
        return RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION;
    if (
        isValidPatternPassport(value, originCountry) &&
        config[originCountry].isValidPassportAlgorith()
    )
        return RESPONSE_OK_DOCUMENT_VALIDATION;
    return RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION;
};

const getValidateResidentDocument = (value, originCountry) => {
    if (!isValidLengthResident(value, originCountry))
        return RESPONSE_KO_LENGTH_DOCUMENT_VALIDATION;
    if (
        isValidPatternResident(value, originCountry) &&
        config[originCountry].isValidResidentAlgorith(value)
    )
        return RESPONSE_OK_DOCUMENT_VALIDATION;
    return RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION;
};

const getDocumentGroupByOriginCountry = (documentType, originCountry) => {
    const documentGroupMap = config[originCountry].documentGroupMap;
    const documentGroup = Object.keys(documentGroupMap).find(k =>
        documentGroupMap[k].includes(documentType)
    );
    return documentGroup;
};

/**
 *
 * @param {string} value
 * @param {string} documentType
 * @returns {object} {object.error {integer}, object.valid {boolean}}
 *
 */
const getValidation = (value, documentType) => {
    const originCountry = getCountryByDocumentType(documentType);
    const documentGroup = getDocumentGroupByOriginCountry(
        documentType,
        originCountry
    );
    let response;
    switch (documentGroup) {
        case NATIONAL_DOCUMENT:
            response = getValidateNationalDocument(value, originCountry);
            break;
        case PASSPORT_DOCUMENT:
            response = getValidatePassport(value, originCountry);
            break;

        case RESIDENT_DOCUMENT:
            response = getValidateResidentDocument(value, originCountry);
            break;

        case OTHER_DOCUMENT:
            response = RESPONSE_OK_DOCUMENT_VALIDATION;
            break;

        default:
            response = RESPONSE_KO_PATTERN_DOCUMENT_VALIDATION;
            break;
    }

    return response;
};

const postalCodeES = value => {
    return /^\d{5}$/.test(value.trim());
};

const postalCodeDE = value => {
    return /^\d{5}$/.test(value.trim());
};

const postalCodeNL = value => {
    return /^[0-9]{4}(\ |\-)?[a-z]{2}$/i.test(value.trim());
};

const postalCodePT = value => {
    return /^[a-z0-9]{4}-[a-z0-9]{3}$/i.test(value.trim());
};

const dashRegExp = new RegExp(
    /^(?:[\s\u0027\u005E\u0060\u00B4]?[a-zA-Z\-\u00C1-\u00C7\u00C9-\u00CB\u00CD-\u00D1\u00D3-\u00D8\u00DA-\u00DF\u00E1-\u00E7\u00E9-\u00EB\u00ED-\u00F1\u00F3-\u00F8\u00FA-\u00FF\u0152-\u0178]*){0,}$/
);

// eslint-disable-next-line no-unused-vars
const noDashRegExp = new RegExp(
    /^(?:[a-zA-Z\u00C0-\u00FF\u0152-\u0178]+[\s\u0027\u005E\u0060\u00B4]?[a-zA-Z\u00C0-\u00FF\u0152-\u0178]*){0,}$/
);

const dashRegExpNL = new RegExp(
    /^(?:[\s\u0027\u005E\u0060\u00B4]?[a-zA-Z\-\u00C1-\u00C7\u00C9-\u00CB\u00CD-\u00D1\u00D3-\u00D8\u00DA-\u00DF\u00E1-\u00E7\u00E9-\u00EB\u00ED-\u00F1\u00F3-\u00F8\u00FA-\u00FF\u0152-\u0178\u0027\u005E\u0060\u00B4]*){0,}$/
);

const dashWithNoEspecialsCharacters = new RegExp(
    /^(?:[\s\u005E]?[a-zA-Z\-\u00C1-\u00C6\u00C9-\u00CB\u00CD-\u00D1\u00D3-\u00D8\u00DA-\u00DF\u00E1-\u00E6\u00E9-\u00EB\u00ED-\u00F1\u00F3-\u00F8\u00FA-\u00FF\u0152-\u0178]*){0,}$/
);

const noDashWithNoEspecialsCharacters = new RegExp(
    /^(?:[\s\u005E]?[a-zA-Z\u00C1-\u00C6\u00C9-\u00CB\u00CD-\u00D1\u00D3-\u00D8\u00DA-\u00DF\u00E1-\u00E6\u00E9-\u00EB\u00ED-\u00F1\u00F3-\u00F8\u00FA-\u00FF\u0152-\u0178]*){0,}$/
);

const noOrdinaryCharactersRegExp = /^[A-Za-z0-9À-ÿ'_./\\?:;-\s\u00C7\u00E7\u005B\u005D\u003C\u003E\u00B4]+$/i;

const noOrdinaryCharactersRegExpWithDotAndComma = /^[A-Za-z0-9À-ÿ'_.,/\\?:;-\s\u00C7\u00E7\u005B\u005D\u003C\u003E\u00B4]+$/i;

const alphanumericRegExp = new RegExp(/^(?:[a-zA-Z0-9]+[\s]?[a-zA-Z0-9]*){0,}$/);

const alphabetRegExp = new RegExp(/^([a-zA-Z]+[\s]?[a-zA-Z]*){0,}$/);

const getNamingValidationRegExp = {
    [COUNTRY_CODE_ES]: noDashWithNoEspecialsCharacters,
    [COUNTRY_CODE_DE]: dashRegExp,
    [COUNTRY_CODE_NL]: dashRegExp,
    [COUNTRY_CODE_PT]: dashRegExp
};

const getLastNameValidationRegExp = {
    [COUNTRY_CODE_ES]: dashWithNoEspecialsCharacters,
    [COUNTRY_CODE_DE]: dashRegExp,
    [COUNTRY_CODE_NL]: dashRegExpNL,
    [COUNTRY_CODE_PT]: dashRegExp
};

const postalCode = {
    [COUNTRY_CODE_ES]: value => postalCodeES(value),
    [COUNTRY_CODE_DE]: value => postalCodeDE(value),
    [COUNTRY_CODE_NL]: value => postalCodeNL(value),
    [COUNTRY_CODE_PT]: value => postalCodePT(value)
};

const birthYearMatchesPassword = (password, birthYear) => {
    return password === birthYear;
}

const birthDayMatchesPassword = (password, birthDay, birthMonth) => {
    const day = birthDay ? (birthDay.length === 1 ? '0' + birthDay : birthDay) : "00";
    const month = birthMonth ? (birthMonth.length === 1 ? '0' + birthMonth : birthMonth) : "00";
    return password === day + month || password === month + day;
}

module.exports = {
    getValidation,
    postalCode,
    getNamingValidationRegExp,
    getLastNameValidationRegExp,
    noOrdinaryCharactersRegExp,
    validateCellPhone,
    alphanumericRegExp,
    alphabetRegExp,
    birthYearMatchesPassword,
    birthDayMatchesPassword,
    noOrdinaryCharactersRegExpWithDotAndComma
};
